import React, { FC } from 'react';
import { GenNavTile, UniversalLink } from '@/components';
import {
  TypeAccountNavTileFields,
  TypeLink_internalFields,
} from '@/core/generated-types';
import {
  CTA_NAMES,
  PAGE_LOCATIONS,
  trackItemClickedEvent,
  CLICKED_ITEM_TYPES,
  buildPayloadUrl,
} from '@/utils/rudderstack';
import { getCtaTextStyles } from '@/components/utils';

export type ERCSubscriptionTileProps = {
  tile?: TypeAccountNavTileFields;
};

const ERCSubscriptionTile: FC<ERCSubscriptionTileProps> = ({ tile }) => {
  if (!tile) return null;

  const sendItemClickedEvent = () => {
    trackItemClickedEvent({
      url: buildPayloadUrl(tile.buttonLink?.fields as TypeLink_internalFields),
      type: CLICKED_ITEM_TYPES.LINK,
      pageLocation: PAGE_LOCATIONS.EARLY_READER_CLUB_SUBSCRIPTION_TILE,
      cta: CTA_NAMES.VIEW,
    });
  };

  return (
    <GenNavTile
      title={tile.title}
      subTitle={tile.subheader}
      description={tile.description}
      titleDecorator={
        <UniversalLink
          link={tile.buttonLink}
          classes={`w-fit underline font-bold ${getCtaTextStyles()}`}
          onClick={sendItemClickedEvent}
        />
      }
    />
  );
};

export default React.memo(ERCSubscriptionTile);
